/* ---- thumb controls ------------------------------------------------------
   Hidden until packages/client/src/touch.js sees a real touch and puts `.touch` on the
   root, so a desktop never pays for them and a laptop with a touchscreen gets
   them the moment somebody actually touches it rather than on a guess.

   The layer is pointer-events:none and only the buttons take input back: the
   stick and the look drag are read off the CANVAS underneath, which means
   there is no widget to hit and nothing to miss. */
#touch{display:none;position:fixed;inset:0;z-index:4;pointer-events:none}
html.touch #touch{display:block}
/* The desktop affordances the thumbs replace.  #charge goes because the jump
   button fills instead, and a meter at the bottom centre is a long way from
   where a phone player is looking; #look-hint and #keys because they document
   a mouse and a keyboard that are not there. */
html.touch #look-hint,html.touch #charge,html.touch #keys{display:none}
/* A panel owns the screen: the thumb controls go away rather than floating
   over the cat builder, and main.js drops whatever was latched. */
html.panelled #touch{display:none}
/* Top-centre is taken on a phone: the cat-builder button owns the top-left
   and the happiness panel hangs under it, and at 412 px the toast lands on
   both.  Bottom-centre is the one band nothing else claims, between the
   stick and the button stack. */
html.touch #bliss{top:auto;bottom:calc(52px + env(safe-area-inset-bottom));
  max-width:calc(100vw - 210px)}

/* A zero-sized point that touch.js translates to wherever the thumb landed;
   both children hang off it and centre themselves with margins, so one
   transform moves the whole stick and a second moves only the knob. */
#stick{position:fixed;left:0;top:0;width:0;height:0;opacity:0;
  transition:opacity .12s ease-out}
#stick.shown{opacity:1}
#stick i{position:absolute;left:0;top:0;display:block;border-radius:50%}
#stick-ring{width:104px;height:104px;margin:-52px 0 0 -52px;
  border:1px solid var(--edge);background:rgba(20,21,18,.34);
  backdrop-filter:blur(5px);-webkit-backdrop-filter:blur(5px)}
#stick-knob{width:46px;height:46px;margin:-23px 0 0 -23px;
  background:rgba(241,239,232,.28);border:1px solid var(--edge);
  transition:background .12s,border-color .12s}
/* Past the sprint threshold the knob takes the HUD's "on" colour -- the same
   signal the keycaps and the charge meter use -- so "I am running" is legible
   without looking away from the cat. */
#stick.run #stick-knob{background:var(--accent);border-color:var(--accent)}

#pads{position:fixed;right:calc(14px + env(safe-area-inset-right));
  bottom:calc(16px + env(safe-area-inset-bottom));
  display:flex;flex-direction:column-reverse;align-items:center;gap:11px;
  pointer-events:none}
#pads button{
  pointer-events:auto;touch-action:none;-webkit-user-select:none;user-select:none;
  -webkit-tap-highlight-color:transparent;position:relative;
  font-family:inherit;letter-spacing:.1em;text-transform:uppercase;
  color:var(--ink);background:var(--panel);border:1px solid var(--edge);
  border-radius:50%;display:flex;align-items:center;justify-content:center;
  backdrop-filter:blur(9px);-webkit-backdrop-filter:blur(9px);
  transition:background .12s,border-color .12s,color .12s}
#pads button span{position:relative;z-index:1}
/* Sized by how often each is wanted and how bad a miss is.  All four clear
   the 44 px both platform guidelines call the floor; jump is nearest the
   thumb's rest position and biggest because a missed pounce is a missed
   happy place.  Meow is sit-sized -- a flourish, and a missed meow costs
   nothing -- and rides at the far end of the stack (last in DOM; the
   column is reversed) so the three verbs the thumb already knows stay
   exactly where muscle memory left them. */
[data-touch="jump"]{width:78px;height:78px;font-size:.66rem}
[data-touch="claw"]{width:62px;height:62px;font-size:.6rem}
[data-touch="sit"]{width:50px;height:50px;font-size:.54rem}
[data-touch="meow"]{width:50px;height:50px;font-size:.54rem}
#pads button.on{color:#171812;background:var(--accent);border-color:var(--accent)}
/* The pounce, drawn where the thumb already is.  A conic sweep rather than a
   bar because the button is a circle and a round meter needs no legend: the
   accent closes clockwise and meets itself at full charge. */
[data-touch="jump"]::before{content:"";position:absolute;inset:-1px;
  border-radius:50%;pointer-events:none;opacity:.5;
  background:conic-gradient(var(--accent) calc(var(--charge,0) * 360deg),
                            transparent 0)}
[data-touch="jump"].ready{border-color:var(--accent)}
[data-touch="jump"].ready::before{opacity:.92}
@media (prefers-reduced-motion:reduce){
  #stick,#stick-knob,#pads button{transition:none}
}
